import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=305f9ea8&scoped=true"
import script from "./Language.vue?vue&type=script&lang=js"
export * from "./Language.vue?vue&type=script&lang=js"
import style0 from "./Language.vue?vue&type=style&index=0&id=305f9ea8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305f9ea8",
  null
  
)

export default component.exports